import './Legend.scss'

const ChartLegend = (props: { color: string; value: { percent: number; number: number }; legend: string }) => {
  return (
    <div>
      <div style={{ display: 'flex', width: '100%' }}>
        <div
          style={{
            background: props.color,
            height: '8px',
            width: '8px',
            borderRadius: '100%',
            margin: '5px 4px',
          }}
        />
        <div style={{ width: '100px' }}>
          <p className="legend-text">
            {props.legend}
            <br />
            <span>
              <strong> %{props.value.percent} </strong>({props.value.number === null ? 0 : props.value.number})
            </span>
          </p>
        </div>
      </div>
    </div>
  )
}

export default ChartLegend
